(function () {
	'use strict';

	var initiativeChartProperties = {
		eventName: 'event:generalProjectSavingsCtrl:getChart', // event watched by directive
		fmtService: 'currencyFormatService',
		savingsTypeFilterTranslation: {
			'totalSavings': 'Total Savings',
			'weightedSavings': 'Weighted Target Savings',
			'annualSavings': 'Annual Savings',
			'oneTimeSavings': 'One Time Savings',
			'costAvoidence': 'Cost Avoidance',
			'implementationCost': 'Implementation Cost'
		}
	};

	angular.module('app.dashboard')
		.directive('genericProjectWidget', genericProjectWidgetDirective);

	genericProjectWidgetDirective.$inject = ['$rootScope', '$translate', '$filter', '$window', 'currencyFormatService',
		'numberFormatService', 'integerFormatService', 'leanFilterService', 'leanProjectSummaryService'];

	function genericProjectWidgetDirective($rootScope, $translate, $filter, $window, currencyFormatService,
			numberFormatService, integerFormatService, leanFilterService, leanProjectSummaryService) {

		// current services that are being used, will need to add them to this object if we add more
		var services = {
			'currencyFormatService': currencyFormatService,
			'numberFormatService': numberFormatService,
			'integerFormatService': integerFormatService
		};

		return {
			restrict: 'A',
			scope: {
				chartId: '@chartId'
			}, //chartId passed in from controller via HTML
			link: function (scope, elem, attrs) {
				//get the window width to help with responsiveness
				var chart;
				var targetCurrency;
				var categoryTimeOut;
				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				var patternColors = ['#005DA7', '#0082E5', '#79C3FC', '#D7D7D7', '#9675E2'];
				scope.height = window.innerHeight;

				elem[0].id = elem[0].id + scope.$id;
				var scopeAccessor = scope.$parent.$parent;
				var groupBy = scopeAccessor.viewType;
				var displayType = scopeAccessor.displayType;
				var baseWidgetHeight = 250;
				var slideshow = false;
				scope.paddingTop = 4;
				var categoryMap = {};

				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					baseWidgetHeight = scope.height - 130;
					scope.paddingTop = 8;
					slideshow = true;
				}

				if (width > 992) {
					scope.paddingRt = slideshow ? 58 : 45;
					scope.paddingLt = slideshow ? 260 : 180;
					scope.rectSide = slideshow ? 14 : 10;
					scope.fontSize = slideshow ? '14px' : '10px';
				} else if (width >= 768) {
					scope.paddingRt = slideshow ? 58 : 35;
					scope.paddingLt = slideshow ? 260 : 180;
					scope.rectSide = slideshow ? 14 : 8;
					scope.fontSize = slideshow ? '14px' : '8px';
				} else {
					scope.paddingRt = slideshow ? 58 : 25;
					scope.paddingLt = slideshow ? 260 : 180;
					scope.rectSide = slideshow ? 14 : 6;
					scope.fontSize = slideshow ? '14px' : '6px';
				}

				scope.getWindowDimensions2 = function () {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				};
				// update on window resize
				scope.$watch(scope.getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;
					if (scope.windowWidth2 >= 992) {
						scope.paddingRt = slideshow ? 58 : 45;
						scope.paddingLt = slideshow ? 260 : 180;
						scope.rectSide = slideshow ? 14 : 10;
						scope.fontSize = slideshow ? '14px' : '10px';
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingRt = slideshow ? 58 : 35;
						scope.paddingLt = slideshow ? 260 : 180;
						scope.rectSide = slideshow ? 14 : 8;
						scope.fontSize = slideshow ? '14px' : '8px';
					} else {
						scope.paddingRt = slideshow ? 58 : 25;
						scope.paddingLt = slideshow ? 260 : 180;
						scope.rectSide = slideshow ? 14 : 6;
						scope.fontSize = slideshow ? '14px' : '6px';
					}

					if (slideshow) {
						baseWidgetHeight = scope.height - 200;
					}

					if (currentPaddingLeft !== scope.paddingLt || slideshow) {
						generateChart();
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				//reading in the chart properties for this chart
				var chartKey = scope.chartId;
				var formatServiceType, fmtService, isCurrencyFormatService;
				var eventName = initiativeChartProperties.eventName;
				setupDefaults(scopeAccessor.displayType);

				function setupDefaults(displayType) {
					formatServiceType = displayType === 'numberOfProjects' ? 'numberFormatService' :
						initiativeChartProperties.fmtService;
					fmtService = services[formatServiceType];
					isCurrencyFormatService = displayType !== 'numberOfProjects';
					groupBy = scopeAccessor.viewType;
				}

				var getStackSum = function (d) {
					var sum = 0;
					for (var prop in d) {
						if (d.hasOwnProperty(prop) && !isNaN(d[prop]) && prop !== 'id') {
							sum += d[prop];
						}
					}
					return sum;
				};

				function addCategoriesTitle(elemId, groups) {
					var categoriesContainer = d3.selectAll(elemId + ' .c3-axis.c3-axis-x .tick')._groups[0];
					for (var i = 0; i < categoriesContainer.length; i++) {
						var categoryText = d3.select(categoriesContainer[i]).text();
						d3.select(categoriesContainer[i]).append('title').text(categoryMap[categoryText]);
					}
				}

				function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						nameFormat = config.tooltip_format_name || function (name) {
							return name;
						},
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, title, value, name, bgcolor;

					for (i = 0; i < d.length; i++) {
						if (!(d[i] && (d[i].value || d[i].value === 0))) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class="' + CLASS.tooltip + '">' +
								(title || title === 0 ?
									'<tr><th colspan="2">' + categoryMap[title] + '</th></tr>' :
									'');
						}
						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (value !== undefined) {
							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + color(d[i]) + '"></span>' +
								$translate.instant(d[i].name) + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}

				function addHyperLinks(elemId, categories, groupBy, chartCategoriesToId) {
					var kanbanUrl = '/application/f/home.html#/lean-projects/projects-kanban/?drilldown=1&' +
						(groupBy == 'Areas' ? 'projectArea':
							groupBy == 'BusinessUnit' ? 'businessunit' :'factory') + '=';
					d3.selectAll(elemId + ' .c3-axis.c3-axis-x .tick tspan')
						.on('click', function (d, i) {
							var savingsType = scopeAccessor.mode;
							var savingsBySavingType = scopeAccessor.displayType.split('-');
							if (savingsType === 'Count') {
								savingsType = 'Target ';
							} else if (savingsBySavingType[1] === 'weightedSavings') {
								savingsType = '';
							} else {
								savingsType += ' ';
							}
							savingsType += initiativeChartProperties.savingsTypeFilterTranslation[savingsBySavingType[1]];
							var filters = scopeAccessor.filterService;
							var timePeriodParams = leanFilterService.getTimePeriodFilterQueryParam('timePeriod', filters.getSelected('Time Period'), true, true);
							var archivedStageIds = null;
							if (filters.getSelected('Lean Project Stage')) {
								archivedStageIds = filters.getSelected('Lean Project Stage');
							} else {
								archivedStageIds = leanProjectSummaryService.getArchiveStageIds(filters.getObjectList('Lean Project Stage'));
								if (archivedStageIds.length == 0) {
									archivedStageIds = null;
								}
							}
							var queryParams = {
								'projectManagerId': filters.getSelected('Lean Project Manager'),
								'projectType': filters.getSelected('Lean Project Type'),
								'projectCategoryId': filters.getSelected('Lean Project Category'),
								'projectSavings': savingsType,
								'projectGoalId': filters.getSelected('Lean Project Goals'),
								'projectSavingsCategoryId': filters.getSelected('ProjectSavingsCategories')
							};
							if (archivedStageIds) {
								queryParams['stageId'] = archivedStageIds;
							}
							queryParams = _.merge(queryParams, timePeriodParams);
							if (groupBy == 'Areas') {
								queryParams['factory'] = filters.getSelected('Factory');
								if (filters.getSelected('Business Unit')) {
									queryParams['businessunit'] = filters.getSelected('Business Unit');
								}
							} else if (groupBy == 'BusinessUnit') {
								queryParams['projectArea'] = filters.getSelected('Lean Project Area');
								queryParams['factory'] = filters.getSelected('Factory');
							} else {
								queryParams['projectArea'] = filters.getSelected('Lean Project Area');
							}
							var url = addQueryParam(kanbanUrl +
								encodeURIComponent((groupBy == 'Areas' || groupBy == 'BusinessUnit' ?
									categories[d.splitted]: chartCategoriesToId[categories[d.splitted]])),
							filters.getSelected('Factory'), queryParams);
							var filterQueryParam = getFilterQueryParam();
							if (filterQueryParam) {
								url += '&filter=' + filterQueryParam;
							}
							window.open(url, '_blank');
						});
				}
				var groupsState = {};

				function getFilterQueryParam() {
					var queryParamsObj =  leanFilterService.getQueryParamsObject();
					return queryParamsObj.filter;
				}

				function generateChart() {
					setupDefaults(scopeAccessor.displayType);
					var data = scopeAccessor.chartData;
					var groups = scopeAccessor.chartGroups;
					var chartCategories = scopeAccessor.chartCategories;
					var chartCategoriesToId = scopeAccessor.categoriesToId;
					targetCurrency = scopeAccessor.targetCurrency;
					var categories = [];

					// abbreviate the vertical axis labels to fit
					var limitLabelWidth = slideshow ? 225 : 165;
					var tempSvg = d3.select('body').append('svg');
					var tempTextElement = tempSvg.append('text');
					angular.forEach(chartCategories, function (category) {
						var tempCategory = category;
						tempTextElement.text(tempCategory);
						var trimAmount = 0;
						var textSize = tempTextElement.node().getBBox();
						// font isn't monospace, so have to draw and measure the text to trim to a given width
						while (textSize.width > limitLabelWidth) {
							trimAmount += 1;
							tempCategory = category.substring(0, category.length - trimAmount) + '..';
							tempTextElement.text(tempCategory);
							textSize = tempTextElement.node().getBBox();
						}
						categoryMap[tempCategory] = category;
						categories.push(tempCategory);
					});
					tempTextElement.remove();
					tempSvg.remove();

					angular.forEach(groups, function (group) {
						groupsState[group] = true;
					});

					if (!data) {
						return;
					}

					var tickValues = [];
					if (displayType === 'numberOfProjects') {
						// count projects in areas and generate tick values
						var maxProjectCount = 0;
						var i;
						for (i = 0; i < data.length; i++) {
							var projectCount = 0;
							for (var j = groups.length - 1; j >= 0; j--) {
								projectCount += data[i][groups[j]];
							}
							if (projectCount > maxProjectCount) {
								maxProjectCount = projectCount;
							}
						}
						var interval = 1;
						if (maxProjectCount > 12) {
							interval = maxProjectCount / 6;
						}
						for (i = 0; i <= maxProjectCount; i += interval) {
							tickValues.push($filter('number')(i, 0));
						}
						if (parseInt(tickValues[tickValues.length - 1]) !== maxProjectCount) {
							tickValues.push($filter('number')(maxProjectCount, 0));
						}
					}

					var config = {};
					config.bindto = '#' + elem[0].id;
					config.data = {};
					config.data.keys = {
						value: groups
					};

					config.data.json = data;
					config.data.type = 'bar';
					config.data.order = null;
					config.data.labels = {
						format: function (v, id, i, j) {
							if (v > 0) {
								return isCurrencyFormatService ? fmtService.get(v, targetCurrency) : fmtService.get(v);
							}
						}
					};
					config.data.labels = false;
					config.data.groups = [groups];
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt,
						top: scope.paddingTop,
						bottom: scope.paddingTop
					};
					config.axis = {};
					config.axis.x = {
						type: 'category',
						categories: categories,
						tick: {
							multiline: false
						}
					};
					var yAxisMin = d3.min([0, d3.min(data, getStackSum)]);
					config.axis.y = {
						tick: {
							format: function (v, id, i, j) {
								if (v) {
									return isCurrencyFormatService ? fmtService.get(v, targetCurrency) : fmtService.get(v);
								}
							},
							count: slideshow ? 10 : 5,
							multiline: false,
							outer: false
						},
						min: yAxisMin,
						max: d3.max(data, getStackSum),
						padding: {
							bottom: 0
						}
					};
					if (displayType === 'numberOfProjects') {
						config.axis.y.tick.values = tickValues;
					}
					config.axis.rotated = true;
					config.size = {};
					var widgetHeight = baseWidgetHeight;
					if (!slideshow && data.length > 10) {
						widgetHeight += (data.length - 10) * 10;
					}
					config.size.height = widgetHeight;
					config.legend = {};
					config.legend.show = true;
					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};
					if (yAxisMin < 0) {
						config.grid.y.lines = [{
							value: 0,
							text: 0,
							position: 'middle'
						}];
					}
					config.color = {
						pattern: patternColors
					};
					config.tooltip = {
						contents: tooltipFormat
					};

					config.onrendered = function () {
						jQuery('#' + elem.attr('id') + ' .c3-xgrid-lines')
							.prependTo(jQuery('#' + elem.attr('id') + ' .c3-grid').first());
						addHyperLinks(config.bindto, categoryMap, groupBy, chartCategoriesToId);
					};

					chart = c3.generate(config);
					categoryTimeOut = setTimeout(function () {
						addCategoriesTitle(config.bindto, scopeAccessor.chartGroups);
					}, 1000);
				}

				var generateListener = scope.$on('event:generalProjectSavingsCtrl:getChart', function (event) {
					generateChart();
					// setLegendsGapAndSize('#' + elem[0].id);
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (generateListener) {
						generateListener();
					}
					clearTimeout(categoryTimeOut);
				});
			}
		};
	}
})();
